import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  ids: null,
  adasInspection: null,
  adasmatrices: JSON.parse(storage.session.getItem(types.SESSION_ADAS_MATRIX)) || [],
  links: []
})



// WEBPACK FOOTER //
// ./src/store/modules/adas/state.js